export const usePermissions = () => {
  const hasPermission = (permission = '', userPermissions = []) => {
    return userPermissions?.some(p => p.name === permission) ?? false
  }

  const hasAnyPermission = (permissions = [], userPermissions = []) => {
    return permissions.some(permission => hasPermission(permission, userPermissions))
  }

  const hasAllPermissions = (permissions = [], userPermissions = []) => {
    return permissions.every(permission => hasPermission(permission, userPermissions))
  }

  const canCreate = (module = '', userPermissions = []) => {
    return hasPermission(`create-${module}`, userPermissions)
  }

  const canRead = (module = '', userPermissions = []) => {
    return hasPermission(`read-${module}`, userPermissions)
  }

  const canUpdate = (module = '', userPermissions = []) => {
    return hasPermission(`update-${module}`, userPermissions)
  }

  const canDelete = (module = '', userPermissions = []) => {
    return hasPermission(`delete-${module}`, userPermissions)
  }

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    canCreate,
    canRead,
    canUpdate,
    canDelete,
  }
}
